<div class="container-fluid">
  <!-- Session Main Data -->
  <fieldset class="cust-field">
    <legend class="cust-leg">{{'SESSIONMAINDATA' | translate}}</legend>
    <div class="row">
      <div class="col">
        <p-dataTable class="table table-responsive" tableStyleClass="table table-bordered table-striped"
          [value]="patientService" [selectionMode]="'single'">
          <p-column field="serial" header="{{ 'SERIAL' | translate }}" [sortable]="true"></p-column>
          <p-column field="patCode" header="{{ 'PatientCode' | translate }}" [sortable]="true"></p-column>
          <!-- <p-column field="serviceId" header="{{'SERVICECODE' | translate}}"></p-column>
          <p-column field="doctorCode" header="{{'DOCCODE' | translate}}"></p-column> -->

          <p-column field="{{translate.currentLang == 'ar'? 'patientNameAr' : 'patientNameEn'}}"
            header="{{'patient' | translate}}"></p-column>

          <p-column field="{{translate.currentLang == 'ar'? 'serviceNameAr' : 'serviceNameEn'}}"
            header="{{'SERVICENAME' | translate}}"></p-column>

          <p-column field="{{translate.currentLang == 'ar'? 'doctorNameAr' : 'doctorNameEn'}}"
            header="{{'DOCTOR' | translate}}"></p-column>

          <p-column field="{{translate.currentLang == 'ar'? 'nationalityNameAr' : 'nationalityNameEn'}}"
            header="{{'NATIONALITY' | translate}}"></p-column>



          <p-column field="{{translate.currentLang == 'ar'? 'callReasonNameAr' : 'callReasonNameEn'}}"
            header="{{'CALLREASON' | translate}}"></p-column>

          <p-column field="{{translate.currentLang == 'ar'? 'confirmationAr' : 'callReasonNameEn'}}"
            header="{{'BOOKINGSTATUS' | translate}}"></p-column>

          <p-column field="{{translate.currentLang == 'ar'? 'howToReachUsNameAr' : 'howToReachUsNameEn'}}"
            header="{{'HOWTOREACHUS' | translate}}"></p-column>


          <p-column field="{{translate.currentLang == 'ar'? 'vplaceNameAr' : 'vplaceNameEn'}}"
            header="{{'Clinic' | translate}}"></p-column>

          <p-column field="{{translate.currentLang == 'ar'? 'nurseNameAr' : 'nurseNameEn'}}"
            header="{{'NURSE' | translate}}"></p-column>


          <p-column field="expectedStartTime" header="{{'StartTime' | translate}}">
            <ng-template pTemplate="options" let-row="rowData">
              {{row.expectedStartTime | date: 'dd/MM/yyyy, h:mm a'}}
            </ng-template>
          </p-column>
          <p-column field="mobile" header="{{ 'MOBILENUMBER' | translate }}" [sortable]="true"></p-column>
          <p-column field="userCreate" header="{{ 'USERNAME' | translate }}" [sortable]="true"></p-column>
          <p-column header="{{ 'UPDATEUSER' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
              <span>
                {{row.userUpdate }} /{{row.updateDate | date: 'dd/MM/yyyy, h:mm a'}}
              </span>
            </ng-template>
          </p-column>

          <p-column width="100" header="{{ 'ACTIONS' | translate }}" [style]="{'width': '5%'}">
            <ng-template pTemplate="options" let-row="rowData">


              <button type="button" class="btn btn-danger" style="margin: 3px;" (click)="onIconActionClick(row)">
                <i class="fa fa-ban" aria-hidden="true"></i>
                <strong class="list-right-actions">
                  {{
                  translate.currentLang == "ar"
                  ?'الغاء الحجز'
                  : 'Cancel Reservation'

                  }}
                </strong>

              </button>
            </ng-template>
          </p-column>
        </p-dataTable>
      </div>
    </div>
  </fieldset>

  <!-- Session Devices -->
  <fieldset [hidden]="jsonFormSetting?.bodyPart?.hidden==true" class="cust-field mt-3">
    <legend class="cust-leg">
      {{'BODYPART' | translate}}
    </legend>
    <div class="row">
      <div class="col">
        <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="bodyParts"
          [selectionMode]="'single'">
          <p-column field="bodyPart" header="{{ 'SERIAL' | translate }}" [sortable]="true"></p-column>
          <p-column field="{{translate.currentLang == 'ar'? 'nameAr' : 'nameEn'}}" header="{{'BODYPART' | translate}}">
          </p-column>
        </p-dataTable>
      </div>
    </div>
  </fieldset>

  <!-- Session Devices -->
  <fieldset [hidden]="jsonFormSetting?.device?.hidden==true" class="cust-field mt-3">
    <legend class="cust-leg">
      {{'DEVICESUSED' | translate}}
    </legend>
    <div class="row">
      <div class="col">
        <div class="col-5 px-0">
          <sanabel-selectize [appcode]="1113" [multi]="true" [customPlaceHolder]="'DEVICE'"
            [SearchKeys]="{ServiceType: this.serviceType,Type:serviceType}" (addSelected)="addServiceDevices($event)">
          </sanabel-selectize>
        </div>
        <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="devices" [selectionMode]="'single'">
          <p-column field="serial" header="{{ 'SERIAL' | translate }}" [sortable]="true"></p-column>
          <p-column field="{{translate.currentLang == 'ar'? 'deviceNameAr' : 'deviceNameEn'}}"
            header="{{'DEVICE' | translate}}"></p-column>
          <p-column header="{{ 'DEVICEREADBEFORE' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
              <input numbersOnly type="number" class="form-control" [(ngModel)]="row.deviceReadBefore">
            </ng-template>
          </p-column>
          <p-column header="{{ 'DEVICEREADAFTER' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
              <input numbersOnly type="number" class="form-control" [(ngModel)]="row.deviceReadAfter">
            </ng-template>
          </p-column>
          <p-column header="{{'ACTIONS' | translate}}">
            <ng-template pTemplate="options" let-row="rowData">
              <span class="fa fa-trash" (click)="deleteDevice(row)"></span>
            </ng-template>
          </p-column>
        </p-dataTable>
        <div class="col mt-3">
          <btns-ctrl [appCodes]="[1]" (clicked)="onBtnsClicked($event, 1)"></btns-ctrl>
        </div>
      </div>
    </div>
  </fieldset>
  <!-- <fieldset class="cust-field mt-3">
    <legend class="cust-leg">
      <span>
        <i class="fas" [ngClass]="{'fa-chevron-down': !isCollapsedservce, 'fa-chevron-up': isCollapsedservce}" (click)="toggleCollapseservices()"></i>
      </span>
      {{ 'PATIENTSERVICES' | translate }}
    </legend>
    <div *ngIf="!isCollapsedservce">
 
      <p>Service 1</p>
      <p>Service 2</p>
      <p>Service 3</p>
    </div>
  </fieldset> -->
  <!--  -->
  <fieldset class="cust-field mt-3">
    <legend class="cust-leg">
      <span>
        <i class="fas" [ngClass]="{'fa-chevron-down': !isCollapsedservce, 'fa-chevron-up': isCollapsedservce}"
          (click)="toggleCollapseservices()"></i>
      </span>
      {{'PATIENTSERVICES' | translate}}
    </legend>
    <div class="row" *ngIf="!isCollapsedservce">
      <div class="col mt-3">

        <a style="font-size: 16px;" href="avascript:void(0);" (click)="showhistorypopup()">{{'PATIENTSERVICES'
          |translate }}</a>
      </div>
    </div>
  </fieldset>

  <!--  -->

  <!-- Session NURSESTAFF -->
  <fieldset class="cust-field mt-3">
    <legend class="cust-leg">
      <span>
        <i class="fas" [ngClass]="{'fa-chevron-down': !isCollapsedservcenurse, 'fa-chevron-up': isCollapsedservcenurse}"
          (click)="toggleCollapsenurse()"></i>
      </span>
      {{'NURSESTAFF' | translate}}
    </legend>

    <div class="row" *ngIf="!isCollapsedservcenurse">
      <div class="col">
        <div class="col-5 px-0">
          <sanabel-selectize appcode="1307" [customPlaceHolder]="'NURSESTAFF'" [multi]="true"
            (addSelected)="addNurses($event)">
          </sanabel-selectize>
        </div>
        <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="nursingList"
          [selectionMode]="'single'">
          <p-column field="empId" header="{{ 'SERIAL' | translate }}" [sortable]="true"></p-column>
          <p-column field="{{translate.currentLang == 'ar'? 'empNameAr' : 'empNameEn'}}"
            header="{{'NURSE' | translate}}"></p-column>
          <p-column header="{{'ACTIONS' | translate}}">
            <ng-template pTemplate="options" let-row="rowData">
              <span class="fa fa-trash" (click)="deleteNurse(row)"></span>
            </ng-template>
          </p-column>
        </p-dataTable>
        <div class="col mt-3">
          <btns-ctrl [appCodes]="[1]" (clicked)="onBtnsClicked($event, 2)"></btns-ctrl>
        </div>
      </div>
    </div>
  </fieldset>
</div>


<div>
  <block-modal-container #popup (close)="onpopupClose($event)">
    <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
  </block-modal-container>
</div>